// extracted by mini-css-extract-plugin
export var cardGrid = "Customization-module--card-grid--38CM1";
export var main = "Customization-module--main--3OQ2F";
export var mainLeft = "Customization-module--main-left--2dAr4";
export var mainCta = "Customization-module--main-cta--2Hlu0";
export var superText = "Customization-module--super-text--3nZa7";
export var white = "Customization-module--white--1nYYc";
export var blue = "Customization-module--blue--3xPUi";
export var pink = "Customization-module--pink--3rySm";
export var card = "Customization-module--card--nfEdx";
export var header = "Customization-module--header--20V4w";
export var mainImage = "Customization-module--main-image--q8qcP";